import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import units from "@frog/source/data/units.js"
import games from "@frog/source/data/games/index.js"

import "@frog/source/views/components/UnitHealthBar.less"

const MAXIMUM_HP = 30
const HP_PER_SEGMENT = 5

export default class UnitHealthBar {
    render() {
        return (
            <div class="UnitHealthBar" style={this.style}>
                {this.fill}
                {this.omegafill}
                {this.borders}
            </div>
        )
    }
    get style() {
        return {
            "width": (this.getProperty("maxhealth") / 20) + "em"
        }
    }
    get fill() {
        return (
            <div class="Fill" style={{
                "width": Math.max(0, this.getProperty("health") / this.getProperty("maxhealth")) * 100 + "%",
            }}/>
        )
    }
    get omegafill() {
        if(this.props.omegaunit != undefined) {
            return (
                <div class="OmegaFill" style={{
                    "width": Math.max(0, ((this.getProperty("health") - this.props.omegaunit.health) / this.getProperty("maxhealth"))) * 100 + "%",
                    "left": Math.max(0, this.props.omegaunit.health / this.getProperty("maxhealth")) * 100 + "%",
                }}/>
            )
        }
    }
    get borders() {
        const borders = []
        for(let i = 0; i < this.getProperty("maxhealth") / HP_PER_SEGMENT; i += 1) {
            borders.push(
                <div class="Border"/>
            )
        }
        return (
            <div class="Borders">
                {borders}
            </div>
        )
    }
    getProperty(propertyName) {
        if(this.props.unit[propertyName] == undefined) {
            if(this.props.unit.jobKey != undefined) return units[this.props.unit.jobKey][propertyName]
            const partyUnit = games[App.game.slug].player.party.units[this.props.unit.key]
            if(partyUnit != undefined) {
                if(partyUnit[propertyName] == undefined) {
                    if(partyUnit.jobKey != undefined) return units[partyUnit.jobKey][propertyName]
                }
                return partyUnit[propertyName]
            }
        }

        return this.props.unit[propertyName]
    }
}
